import React, {useState, useEffect} from 'react';
import * as S from './CategoryBlock.styles';

import apartmentImg from './assets/apartment.png';
import homestayImg from './assets/homestay.png';
import hotelImg from './assets/hotel.png';
import resortImg from './assets/resort.png';
import villaImg from './assets/villa.png';

const CategoryBlock = () => {
    const [data, setData] = useState ([{
        img: '',
        title: 'HOTEL'
    }, {
        img: '',
        title: 'HOMESTAY'
    },
    {
        img: '',
        title: 'RESORT'
    }, {
        img: '',
        title: 'VILLA'
    }, {
        img: '',
        title: 'APARTMENT'
    }]);
    
    useEffect(() => {
        setData([{
        img: hotelImg,
        title: 'HOTELS'
        }, {
        img: homestayImg,
        title: 'HOMESTAYS'
        },
        {
        img: resortImg,
        title: 'RESORTS'
        }, {
        img: villaImg,
        title: 'VILLAS'
        }, {
        img: apartmentImg,
        title: 'APARTMENTS'
        }]);
    }, [])

    return(
        <S.CategoryBlockWrapper>
          <S.CategoryBlock>
            {data.map(item => <S.StayBlockWrapper key={item.title}>
              <S.StayImageBlock src={item.img ? item.img : null} alt=""  loading="lazy"></S.StayImageBlock>
              <S.TextWrapper>{item.title}</S.TextWrapper>
            </S.StayBlockWrapper>)}
          </S.CategoryBlock>
        </S.CategoryBlockWrapper>
    )
}

export default CategoryBlock;